<template>
    <div>
        <o-table ref="tableList" :enable-delete="false"
                 :enable-new="false" :enable-view="false" :enable-edit="false" :title="$t('sandoz.analysis')"
                 :url="'/api/analysis'"
                 :extra-row-button="[{icon: 'arrow-right'}]">
            <template slot="filter">
            </template>
            <template slot="head">
                <o-table-header column="title">{{ $t('sandoz.title') }}</o-table-header>
                <o-table-header column="created_at">{{ $t('sandoz.date') }}</o-table-header>
            </template>
            <template slot="body" slot-scope="props">
                <td>{{props.item.title}}</td>
                <td>{{props.item.created_at | formatDate}}</td>
            </template>
        </o-table>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data: () => ({
    }),
    computed: {
        ...mapGetters({
            user: 'auth/user'
        })
    },
    methods: {

    }
}
</script>
